module.exports = __webpack_public_path__ + "img/tip-velocity.70b373ce.gif";